let data = {};

export default {
  set(key, value) {
    data[key] = value;
  },
  get(key) {
    return data[key];
  },
  clear() {
    data = {};
  },
  dump() {
    return Object.assign({}, data);
  },
};



// WEBPACK FOOTER //
// ./src/lib/store.js